import httpClient from './httpClient';

const td_ginkoia_price = (parameter) => httpClient.post('/api/td_ginkoia_price',parameter);
const td_ginkoia_price_update = (td_ginkoia_price) => httpClient.put('/api/td_ginkoia_price/'+td_ginkoia_price.code_chrono,td_ginkoia_price);

export {
    td_ginkoia_price,
    td_ginkoia_price_update
}